import React, { useState, useRef, useEffect } from "react";
import AppointmentService from '../services/appointmentTimelineService';
import { API_BASE_URL, API_DOCTOR_LIST, API_PATIENT_LIST} from "../../../helpers/urlHelper";
import { getProducts } from '../../ProductCatalog/Service/productServices';

const CreateAppointmentOffcanvas = () => {
  const offcanvasCloseRef = useRef(null);

  // Initialize the service instance
  const appointmentService = new AppointmentService();

  // State for doctors and patients
  const [doctors, setDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productsCita, setProductsCita] = useState([]);
  const [despachosMedicos, setDespachosMedicos] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);

  // Empty initial state for new appointment
  const emptyAppointmentState = {
  userid: '',
  patientName: '',
  patientAvatar: '',
  meetinguserid: '',
  doctorName: '',
  doctorRole: '',
  // ✅ AGREGAR CAMPOS DE PRODUCTOS
  productoCita: '',
  productoCitaName: '',
  despachoMedico: '',
  despachoName: '',
  dateOfBirth: '',
  date: '',
  startTime: '',
  endTime: '',
  address: '',
  medicalHistory: '',
  appointmentType: 'Consultation',
  notes: ''
};

  const [appointment, setAppointment] = useState(emptyAppointmentState);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // Appointment types
  const APPOINTMENT_TYPES = [
    'Consultation',
    'Check-up',
    'Follow-up',
    'Emergency',
    'Vaccination',
    'Laboratory',
    'Radiology',
    'Surgery',
    'Physical Therapy',
    'Mental Health'
  ];

  // Time slots (every 30 minutes from 8:00 to 18:00)
  const TIME_SLOTS = [
    '08:00', '08:30', '09:00', '09:30', '10:00', '10:30',
    '11:00', '11:30', '12:00', '12:30', '13:00', '13:30',
    '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
    '17:00', '17:30', '18:00'
  ];

  // Function to fetch doctors from API
  const fetchDoctors = async () => {
    try {
      const doctorsResponse = await fetch(`${API_DOCTOR_LIST}`);
      if (!doctorsResponse.ok) {
        throw new Error('Failed to fetch doctors');
      }
      const doctorsData = await doctorsResponse.json();
      
      console.log('Raw doctors response:', doctorsData);
      
      const doctorsArray = doctorsData && doctorsData.data ? doctorsData.data : [];
      
      console.log('Processed doctors array:', doctorsArray);
      return doctorsArray;
    } catch (err) {
      console.error('Error fetching doctors:', err);
      return [];
    }
  };

  // Function to fetch patients from API
  const fetchPatients = async () => {
    try {
      const patientsResponse = await fetch(`${API_BASE_URL}${API_PATIENT_LIST}`);
      if (!patientsResponse.ok) {
        throw new Error('Failed to fetch patients');
      }
      const patientsData = await patientsResponse.json();
      
      console.log('Raw patients response:', patientsData);
      
      const patientsArray = patientsData && patientsData.data ? patientsData.data : [];
      
      console.log('Processed patients array:', patientsArray);
      return patientsArray;
    } catch (err) {
      console.error('Error fetching patients:', err);
      return [];
    }
  };

  // Agregar después de fetchPatients
const fetchProductsCita = async () => {
  try {
    setLoadingProducts(true);
    console.log('🔍 Cargando productos de cita...');
    
    const response = await getProducts({
      type: 'service',
      isActive: true
    });
    
    let productData = [];
    if (Array.isArray(response)) {
      productData = response;
    } else if (response.data && Array.isArray(response.data)) {
      productData = response.data;
    } else if (response.data && Array.isArray(response.data.data)) {
      productData = response.data.data;
    }
    
    // Filtrar productos excluyendo los despachos médicos
    const filteredProducts = productData.filter(
      product => product.serviceType !== 'despacho_medico'
    );
    
    console.log('✅ Productos de cita cargados:', filteredProducts.length);
    setProductsCita(filteredProducts);
    
  } catch (error) {
    console.error('❌ Error cargando productos de cita:', error);
  } finally {
    setLoadingProducts(false);
  }
};

const fetchDespachosMedicos = async () => {
  try {
    setLoadingProducts(true);
    console.log('🔍 Cargando despachos médicos...');
    
    const response = await getProducts({
      serviceType: 'despacho_medico',
      isActive: true
    });
    
    let despachoData = [];
    if (Array.isArray(response)) {
      despachoData = response;
    } else if (response.data && Array.isArray(response.data)) {
      despachoData = response.data;
    } else if (response.data && Array.isArray(response.data.data)) {
      despachoData = response.data.data;
    }
    
    console.log('✅ Despachos médicos cargados:', despachoData.length);
    setDespachosMedicos(despachoData);
    
  } catch (error) {
    console.error('❌ Error cargando despachos médicos:', error);
  } finally {
    setLoadingProducts(false);
  }
};

  // Reset form to empty state
  const resetOffcanvas = () => {
    setAppointment(emptyAppointmentState);
    setError(null);
    setSuccessMessage(null);
  };
  
  // Load data when component mounts
useEffect(() => {
  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const doctorsData = await fetchDoctors();
      const patientsData = await fetchPatients();
      await fetchProductsCita();
      await fetchDespachosMedicos();
      
      setDoctors(doctorsData);
      setPatients(patientsData);
      
      setLoading(false);
    } catch (error) {
      console.error('Error loading data:', error);
      setError('Failed to load form data.');
      setLoading(false);
    }
  };

  loadData();
}, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAppointment(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePatientChange = (e) => {
    const selectedPatientId = e.target.value;
    const selectedPatient = patients.find(p => p._id === selectedPatientId);
    
    setAppointment(prev => ({
      ...prev,
      userid: selectedPatientId,
      patientName: selectedPatient ? `${selectedPatient.name || ''} ${selectedPatient.surname || selectedPatient.lastName || ''}`.trim() : '',
      patientAvatar: selectedPatient ? selectedPatient.avatar || '' : '',
      dateOfBirth: selectedPatient ? selectedPatient.dateOfBirth || '' : '',
      address: selectedPatient ? selectedPatient.address || '' : ''
    }));
  };

  const handleDoctorChange = (e) => {
    const selectedDoctorId = e.target.value;
    const selectedDoctor = doctors.find(d => d._id === selectedDoctorId);
    
    setAppointment(prev => ({
      ...prev,
      meetinguserid: selectedDoctorId,
      doctorName: selectedDoctor ? `Dr. ${selectedDoctor.name || ''} ${selectedDoctor.surname || selectedDoctor.lastName || ''}`.trim() : '',
      doctorRole: selectedDoctor ? selectedDoctor.role || 'Doctor' : ''
    }));
  };

  const handleProductoCitaChange = (e) => {
  const selectedProductId = e.target.value;
  const selectedProduct = productsCita.find(p => p._id === selectedProductId);
  
  setAppointment(prev => ({
    ...prev,
    productoCita: selectedProductId,
    productoCitaName: selectedProduct ? (selectedProduct.productName || selectedProduct.name || '') : ''
  }));
};

const handleDespachoMedicoChange = (e) => {
  const selectedDespachoId = e.target.value;
  const selectedDespacho = despachosMedicos.find(d => d._id === selectedDespachoId);
  
  setAppointment(prev => ({
    ...prev,
    despachoMedico: selectedDespachoId,
    despachoName: selectedDespacho ? (selectedDespacho.productName || selectedDespacho.name || '') : ''
  }));
};

  const handleStartTimeChange = (e) => {
    const startTime = e.target.value;
    setAppointment(prev => ({
      ...prev,
      startTime: startTime,
      endTime: calculateEndTime(startTime)
    }));
  };

  const calculateEndTime = (startTime) => {
    if (!startTime) return '';
    
    const [hours, minutes] = startTime.split(':');
    const startDate = new Date();
    startDate.setHours(parseInt(hours), parseInt(minutes), 0);
    
    // Add 30 minutes for default appointment duration
    const endDate = new Date(startDate.getTime() + 30 * 60000);
    
    return endDate.toTimeString().slice(0, 5);
  };

  const validateForm = () => {
    // Limpiar errores previos
    setError(null);
    
    // Validaciones básicas
    if (!appointment.userid) {
      setError('Por favor selecciona un paciente');
      return false;
    }
    
    if (!appointment.meetinguserid) {
      setError('Por favor selecciona un doctor');
      return false;
    }
    
    if (!appointment.date) {
      setError('Por favor selecciona la fecha de la cita');
      return false;
    }
    
    if (!appointment.startTime) {
      setError('Por favor selecciona la hora de inicio');
      return false;
    }
    
    if (!appointment.endTime) {
      setError('Por favor selecciona la hora de fin');
      return false;
    }
    
    if (!appointment.appointmentType) {
      setError('Por favor selecciona el tipo de cita');
      return false;
    }

if (!appointment.productoCita) {
  setError('Por favor selecciona el producto/servicio de la cita');
  return false;
}

if (!appointment.despachoMedico) {
  setError('Por favor selecciona el despacho médico');
  return false;
}
    
    // Validar que la hora de fin sea después de la hora de inicio
    if (appointment.startTime >= appointment.endTime) {
      setError('La hora de fin debe ser posterior a la hora de inicio');
      return false;
    }
    
    // Validar que la fecha de la cita no sea en el pasado
    const appointmentDate = new Date(appointment.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (appointmentDate < today) {
      setError('La fecha de la cita no puede ser en el pasado');
      return false;
    }
    
    // Validar que la fecha no sea más de 1 año en el futuro
    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    
    if (appointmentDate > oneYearFromNow) {
      setError('La fecha de la cita no puede ser más de un año en el futuro');
      return false;
    }
    
    // Validar horario laboral (8:00 - 18:00)
    const startHour = parseInt(appointment.startTime.split(':')[0]);
    const endHour = parseInt(appointment.endTime.split(':')[0]);
    const endMinutes = parseInt(appointment.endTime.split(':')[1]);
    
    if (startHour < 8) {
      setError('Las citas no pueden comenzar antes de las 8:00 AM');
      return false;
    }
    
    if (endHour > 18 || (endHour === 18 && endMinutes > 0)) {
      setError('Las citas no pueden terminar después de las 6:00 PM');
      return false;
    }
    
    // Validar duración mínima (15 minutos)
    const startTime = new Date(`2000-01-01T${appointment.startTime}`);
    const endTime = new Date(`2000-01-01T${appointment.endTime}`);
    const durationMinutes = (endTime - startTime) / (1000 * 60);
    
    if (durationMinutes < 15) {
      setError('La duración mínima de una cita es de 15 minutos');
      return false;
    }
    
    // Validar duración máxima (4 horas)
    if (durationMinutes > 240) {
      setError('La duración máxima de una cita es de 4 horas');
      return false;
    }
    
    // Verificar que el paciente y doctor existan en los datos cargados
    const selectedPatient = patients.find(p => p._id === appointment.userid);
    const selectedDoctor = doctors.find(d => d._id === appointment.meetinguserid);
    
    if (!selectedPatient) {
      setError('El paciente seleccionado no es válido');
      return false;
    }
    
    if (!selectedDoctor) {
      setError('El doctor seleccionado no es válido');
      return false;
    }
    
    // Validar longitud de campos de texto
    if (appointment.notes && appointment.notes.length > 1000) {
      setError('Las notas no pueden exceder 1000 caracteres');
      return false;
    }
    
    if (appointment.medicalHistory && appointment.medicalHistory.length > 2000) {
      setError('El historial médico no puede exceder 2000 caracteres');
      return false;
    }
    
    return true;
  };

  const saveAppointment = async () => {
    setError(null);
    setSuccessMessage(null);
    
    console.log('=== INICIANDO CREACIÓN DE CITA ===');
    console.log('Datos de la cita antes de validación:', appointment);
    
    if (!validateForm()) {
      console.error('Falló la validación del formulario');
      return;
    }
    
    try {
      setLoading(true);
      
      // Verificar que paciente y doctor existan
      const selectedPatient = patients.find(p => p._id === appointment.userid);
      const selectedDoctor = doctors.find(d => d._id === appointment.meetinguserid);
      
      if (!selectedPatient || !selectedDoctor) {
        throw new Error('El paciente o doctor seleccionado no se encontró');
      }
      
      // Preparar datos de la cita con validación adicional
      // En saveAppointment, el appointmentData ya debe incluir:
const appointmentData = {
  userid: appointment.userid,
  patientName: appointment.patientName || `${selectedPatient.name || ''} ${selectedPatient.surname || selectedPatient.lastName || ''}`.trim(),
  patientAvatar: appointment.patientAvatar || selectedPatient.avatar || '',
  meetinguserid: appointment.meetinguserid,
  doctorName: appointment.doctorName || `Dr. ${selectedDoctor.name || ''} ${selectedDoctor.surname || selectedDoctor.lastName || ''}`.trim(),
  doctorRole: appointment.doctorRole || selectedDoctor.role || 'Doctor',
  // ✅ AGREGAR PRODUCTOS
  productoCita: appointment.productoCita,
  productoCitaName: appointment.productoCitaName,
  despachoMedico: appointment.despachoMedico,
  despachoName: appointment.despachoName,
  dateOfBirth: appointment.dateOfBirth || selectedPatient.dob || null,
  date: appointment.date,
  startTime: appointment.startTime,
  endTime: appointment.endTime,
  address: appointment.address || selectedPatient.address || '',
  medicalHistory: appointment.medicalHistory || '',
  appointmentType: appointment.appointmentType,
  notes: appointment.notes || ''
};
      
      console.log('Enviando datos de cita al backend:', JSON.stringify(appointmentData, null, 2));
      
      // El servicio ya maneja la respuesta y errores internamente
      // Si no lanza error, significa que fue exitoso
      const result = await appointmentService.createAppointment(appointmentData);
      
      console.log('Cita creada exitosamente:', result);
      
      // Cerrar el offcanvas inmediatamente
      if (offcanvasCloseRef.current) {
        offcanvasCloseRef.current.click();
      }
      
      // Recargar la página para actualizar los datos
      setTimeout(() => {
        window.location.reload();
      }, 100);
      
    } catch (error) {
      console.error('Error creando cita:', error);
      
      // El servicio ya maneja los errores y los convierte en Error objects
      let errorMessage = 'Ocurrió un error inesperado. Por favor intenta nuevamente.';
      
      if (error.message) {
        // Si el error viene del servicio, usar el mensaje directo
        if (error.message.includes('HTTP Error:') || 
            error.message.includes('Invalid JSON response:') ||
            error.message.includes('fetch')) {
          errorMessage = 'Error de conexión con el servidor. Por favor intenta nuevamente.';
        } else {
          errorMessage = error.message;
        }
      }
      
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleOffcanvasInit = () => {
    resetOffcanvas();
  };

  // Get current date for date input defaults
  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary addnewbtn d-flex align-items-center gap-1" 
        data-bs-toggle="offcanvas"
        data-bs-target="#appointmentOffcanvas"
        aria-controls="appointmentOffcanvas"
        onClick={handleOffcanvasInit}
      >
        <span className="d-block material-symbols-outlined icon-md">add</span>
                                        <span className="d-block">Add New</span>
      </button>

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="appointmentOffcanvas"
        aria-labelledby="appointmentOffcanvasLabel"
        data-bs-backdrop="false"
        style={{ width: '700px' }}
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title" id="appointmentOffcanvasLabel">
            Create New Appointment
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            ref={offcanvasCloseRef}
          ></button>
        </div>
        
        <div className="offcanvas-body">
          {loading && (
            <div className="d-flex justify-content-center my-3">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          
          {successMessage && (
            <div className="alert alert-success" role="alert">
              {successMessage}
            </div>
          )}
          
          <div className="appointment-form">
            {/* Patient and Doctor Section */}
            <div className="mb-4">
              <h6 className="text-primary border-bottom pb-2 mb-3">Patient & Doctor</h6>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="userid" className="form-label">Patient *</label>
                  <select
                    className="form-select"
                    id="userid"
                    name="userid"
                    value={appointment.userid}
                    onChange={handlePatientChange}
                    required
                  >
                    <option value="">Select patient</option>
                    {patients.map(patient => (
                      <option key={patient._id} value={patient._id}>
                        {patient.name || ''} {patient.surname || patient.lastName || ''}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="meetinguserid" className="form-label">Doctor *</label>
                  <select
                    className="form-select"
                    id="meetinguserid"
                    name="meetinguserid"
                    value={appointment.meetinguserid}
                    onChange={handleDoctorChange}
                    required
                  >
                    <option value="">Select doctor</option>
                    {doctors.map(doctor => (
                      <option key={doctor._id} value={doctor._id}>
                        Dr. {doctor.name || ''} {doctor.surname || doctor.lastName || ''}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            {/* Appointment Details Section */}
            <div className="mb-4">
              <h6 className="text-primary border-bottom pb-2 mb-3">Appointment Details</h6>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="date" className="form-label">Date *</label>
                  <input
                    type="date"
                    className="form-control"
                    id="date"
                    name="date"
                    value={appointment.date}
                    onChange={handleInputChange}
                    min={getCurrentDate()}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="appointmentType" className="form-label">Appointment Type *</label>
                  <select
                    className="form-select"
                    id="appointmentType"
                    name="appointmentType"
                    value={appointment.appointmentType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select type</option>
                    {APPOINTMENT_TYPES.map(type => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="startTime" className="form-label">Start Time *</label>
                  <select
                    className="form-select"
                    id="startTime"
                    name="startTime"
                    value={appointment.startTime}
                    onChange={handleStartTimeChange}
                    required
                  >
                    <option value="">Select start time</option>
                    {TIME_SLOTS.map(time => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="endTime" className="form-label">End Time *</label>
                  <select
                    className="form-select"
                    id="endTime"
                    name="endTime"
                    value={appointment.endTime}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select end time</option>
                    {TIME_SLOTS.map(time => (
                      <option key={time} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="mb-4">
  <h6 className="text-primary border-bottom pb-2 mb-3">Products & Services</h6>
  <div className="row">
    <div className="col-md-6 mb-3">
      <label htmlFor="productoCita" className="form-label">Product/Service *</label>
      <select
        className="form-select"
        id="productoCita"
        name="productoCita"
        value={appointment.productoCita}
        onChange={handleProductoCitaChange}
        disabled={loadingProducts}
        required
      >
        <option value="">Select product/service</option>
        {productsCita.map(product => (
          <option key={product._id} value={product._id}>
            {product.productName || product.name || 'Sin nombre'}
            {product.category ? ` - ${product.category}` : ''}
          </option>
        ))}
      </select>
      {loadingProducts && (
        <small className="text-muted">Loading products...</small>
      )}
    </div>
    
    <div className="col-md-6 mb-3">
      <label htmlFor="despachoMedico" className="form-label">Medical Office *</label>
      <select
        className="form-select"
        id="despachoMedico"
        name="despachoMedico"
        value={appointment.despachoMedico}
        onChange={handleDespachoMedicoChange}
        disabled={loadingProducts}
        required
      >
        <option value="">Select medical office</option>
        {despachosMedicos.map(despacho => (
          <option key={despacho._id} value={despacho._id}>
            {despacho.productName || despacho.name || 'Sin nombre'}
            {despacho.category ? ` - ${despacho.category}` : ''}
          </option>
        ))}
      </select>
      {loadingProducts && (
        <small className="text-muted">Loading offices...</small>
      )}
    </div>
  </div>
</div>


            {/* Patient Information Section */}
            <div className="mb-4">
              <h6 className="text-primary border-bottom pb-2 mb-3">Patient Information</h6>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="dateOfBirth" className="form-label">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={appointment.dateOfBirth}
                    onChange={handleInputChange}
                    max={getCurrentDate()}
                    readOnly
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="address" className="form-label">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                    value={appointment.address}
                    onChange={handleInputChange}
                    placeholder="Patient address"
                  />
                </div>
              </div>
            </div>

            {/* Medical Information Section */}
            <div className="mb-4">
              <h6 className="text-primary border-bottom pb-2 mb-3">Medical Information</h6>
              <div className="row">
                <div className="col-12 mb-3">
                  <label htmlFor="medicalHistory" className="form-label">Medical History</label>
                  <textarea
                    className="form-control"
                    id="medicalHistory"
                    name="medicalHistory"
                    value={appointment.medicalHistory}
                    onChange={handleInputChange}
                    rows="3"
                    placeholder="Enter relevant medical history..."
                  />
                </div>
              </div>
            </div>

            {/* Additional Information Section */}
            <div className="mb-4">
              <h6 className="text-primary border-bottom pb-2 mb-3">Additional Information</h6>
              <div className="row">
                <div className="col-12 mb-3">
                  <label htmlFor="notes" className="form-label">Notes</label>
                  <textarea
                    className="form-control"
                    id="notes"
                    name="notes"
                    value={appointment.notes}
                    onChange={handleInputChange}
                    rows="3"
                    placeholder="Enter any additional notes about the appointment..."
                  />
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="d-flex gap-2 pt-3 border-top">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="offcanvas"
              >
                Close
              </button>
              <button 
                type="button" 
                className="btn btn-success flex-grow-1"
                onClick={saveAppointment}
                disabled={loading}
              >
                {loading ? 'Creating...' : 'Create Appointment'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateAppointmentOffcanvas;